// extracted by mini-css-extract-plugin
export default {"modal":"ModalConfrim_modal__YpFrJ","text":"ModalConfrim_text__GgHXJ","btnWrapper":"ModalConfrim_btnWrapper__dQnGy","button":"ModalConfrim_button__Y-qSy"};